import { getUtms } from './utm';

export async function submitWhatsappLead({ name, email, phone, message }) {
  const projectId = import.meta.env.VITE_DEFAULT_PROJECT_ID;
  const apiUrl = import.meta.env.VITE_STRAPI_API_URL || `${import.meta.env.VITE_STRAPI_URL || ''}/api`;
  if (!projectId) throw new Error('Missing WhatsApp project configuration');
  const utms = getUtms(window.location.search);
  const campaign = utms.utm_campaign || '';
  const response = await fetch(`${apiUrl.replace(/\/$/, '')}/whatsapp-messages`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: {
      name, whatsapp_number: phone, message: JSON.stringify({ text: message, email }),
      utm_source: utms.utm_source || '',
      utm_medium: utms.utm_medium || '',
      utm_campaign: campaign ? `${campaign}_-_${projectId}` : projectId,
      utm_content: utms.utm_content || '',
      utm_term: utms.utm_term || '',
      gclid: new URLSearchParams(window.location.search).get('gclid') || '',
    } }),
  });
  const result = await response.json();
  if (!response.ok || result.error || !result.data) throw new Error('WhatsApp lead rejected');
  return result.data;
}
